// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class _Enum {
    IsDefined(enumeration, val) {
        for (const key in enumeration) {
            if (enumeration[key] === val) {
                return true;
            }
        }
        return false;
    }
    TakeKeysFromEnum(enumObject) {
        const keysArr = [];
        for (const key in enumObject) {
            if (isNaN(Number(key))) {
                keysArr.push(key);
            }
        }
        return keysArr;
    }
    TakeValueFromEnum(enumObject) {
        const valuesArr = [];
        for (const key in enumObject) {
            if (!isNaN(Number(key))) {
                valuesArr.push(key);
            }
        }
        return valuesArr;
    }
    GetEnumValues(enumObject) {
        return Object.values(enumObject).filter((value) => typeof value === 'number');
    }
}
export const Enum = new _Enum();
